// v-reveal: simple half-second fade/rise-in on load. No scroll tracking -
// the element just animates in as soon as it mounts.
const prefersReducedMotion = () =>
	window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export default {
	mounted(el) {
		if (prefersReducedMotion()) return;
		el.classList.add('reveal');
	},
};
